// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2H2x6","disabled":"FileBtn_disabled__3q6EU","warn":"FileBtn_warn__1EDdG","fade":"FileBtn_fade__3IYZD"};